var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOfficialNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m7.48.5 2.07 1.504 2.526.4.4 2.526L13.98 7l-1.504 2.07-.4 2.526-2.527.4L7.48 13.5 5.41 11.996l-2.526-.4-.4-2.526L.98 7l1.503-2.07.4-2.526 2.527-.4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "m4.98 7 1.666 1.5 3.334-3"
})));
export default SvgIconOfficialNew;